import axios from 'axios'

/**
 * ProductController 相关接口
 */
export default {
  /**
   * 分页查询商品列表
   * @param {Object} params - 查询参数
   * @param {number} params.pageNum - 页码（默认1）
   * @param {number} params.pageSize - 每页条数（默认10）
   * @param {string} [params.keyword] - 搜索关键词（可选）
   * @returns {Promise} - 分页商品列表
   */
  getProductPage(params) {
    // 仅保留需要的三个参数，自动忽略其他参数
    const { pageNum = 1, pageSize = 10, keyword } = params
    return axios({
      url: '/product-service/api/product/getProductPage',
      method: 'get',
      params: {
        pageNum,
        pageSize,
        ...(keyword && { keyword }) // 仅当keyword存在时才传入
      }
    })
  },
  
  /**
   * 根据ID查询商品
   * @param {number} id - 商品ID
   * @returns {Promise} - 商品详情
   */
  getProductById(id) {
    return axios({
      url: '/product-service/api/product/getProductById', // 接口路径
      method: 'get',
      params: { id } // 以查询参数形式传递id，生成 ?id=xxx 格式
    })
  },
  
  /**
   * 查询商品详情
   * @param {number} id - 商品ID
   * @returns {Promise} - 商品详细信息
   */
  getProductDetail(id) {
    return axios({
      url: `/product-service/api/product/detail/${id}`,
      method: 'get'
    })
  },
  
  /**
   * 查询商品分类
   * @returns {Promise} - 分类列表
   */
  getProductCategories() {
    return axios({
      url: '/api/product/categories',
      method: 'get'
    })
  }
}